<template>
    <div>
        <v-alert
            color="error"
            icon="warning"
            outlined
        >
            {{$t('instance.data_model_error.cant_save_datamodel')}} {{ errors.message }}
        </v-alert>
        <template v-if="errorDetailledMessage">

            <v-btn
                text
                color="primary"
                @click="expand = !expand"
            >Show more details</v-btn>
            <v-expand-transition>
                <div v-show="expand">
                    <vue-markdown :source="errorDetailledMessage"></vue-markdown>
                </div>
            </v-expand-transition>
        </template>
    </div>
</template>

<script>
import VueMarkdown from 'vue-markdown';

export default {

    components: {
        VueMarkdown
    },

    props: {
        errors: {
            type: Object,
            required: true,
        }
    },

    data (){
        return {
            expand: false,
        };
    },

    computed: {
        errorDetailledMessage (){
            return this.$store.getters.datamodelDetailedError(this.errors.error_code);
        },
    },
    methods: {
    },
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/page/Instance/datamodel-checking-error.vue